import styled from '@emotion/styled';
import { useTranslate } from '@tolgee/react';
import dayjs from 'lib/dayjs';
import { useCountDown } from 'ahooks';

const Container = styled.div`
  min-height: 30px;
  background-color: var(--fett-surface-warning-bg);
  font-size: 12px;
  line-height: 30px;
  padding-left: 12px;
`;
interface Props {
  conversation?: Conversation.Conversation;
}
const WhatsappBillingNotice = (props: Props) => {
  const { conversation } = props;
  const { t } = useTranslate();
  const [, { hours, minutes, seconds }] = useCountDown({
    targetDate: new Date(Number(conversation?.waConvInfo?.expireTime ?? 0)),
  });
  if (!conversation || !conversation?.waConvInfo || !conversation?.waUserInfo) {
    return null;
  }
  const { waConvInfo } = conversation;
  const { costType, price, existConv, expireTime } = waConvInfo;
  const getText = () => {
    if (waConvInfo?.costType === 'FREE') {
      return undefined;
    }
    if (!existConv) {
      return costType === 'COST_FREE_QUOTA'
        ? t('scene.chatWorkspace.whatsAppTemplate.billing.consumeQuotaWithFallback')
        : t('scene.chatWorkspace.whatsAppTemplate.billing.deductCoinsWithFallback', {
            amount: price,
          });
    }
    const diff = dayjs(Number(expireTime)).diff(dayjs(), 'second');
    if (diff <= 0) {
      return costType === 'COST_FREE_QUOTA'
        ? t('scene.chatWorkspace.whatsAppTemplate.billing.consumeQuota')
        : t('scene.chatWorkspace.whatsAppTemplate.billing.deductCoins', { amount: price });
    }
    if (diff <= 60 * 60) {
      return t('scene.chatWorkspace.whatsAppTemplate.billing.chargeAgainAfter', {
        duration: ` ${hours}:${minutes}:${seconds} `,
      });
    }
    return undefined;
  };
  const text = getText();
  if (!text) {
    return null;
  }

  return <Container>{text}</Container>;
};

export default WhatsappBillingNotice;
